import { render, staticRenderFns } from "./itemContent.vue?vue&type=template&id=07fc202a&scoped=true&"
import script from "./itemContent.vue?vue&type=script&lang=js&"
export * from "./itemContent.vue?vue&type=script&lang=js&"
import style0 from "./itemContent.vue?vue&type=style&index=0&id=07fc202a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fc202a",
  null
  
)

export default component.exports